import {Action} from "../../../actions/actions";
import {SystemServerVersionsActionTypes} from "../actions/actionTypes";
import _ from "lodash";


export function systemServerVersions(state: string[] = [], action: Action) {
    switch (action.type) {
        case SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS_SUCCESS:
            return _.orderBy(
                action.payload.core_versions.results,
                ["order"]
            );
        case SystemServerVersionsActionTypes.TOGGLE_SYSTEM_SERVER_VERSION_SUCCESS:
            let newState = _.cloneDeep(state);
            const index = _.findIndex(newState, [
                "id",
                action.payload.systemServerVersionId
            ]);
            if (index > -1) {
                newState[index].active = !newState[index].active;
            }
            return newState;
        default:
            return state;
    }
}

export function systemServerVersionsLoading(state: string[] = [], action: Action) {
    switch (action.type) {
        case SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS:
            return true
        case SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS_SUCCESS:
        case SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS_FAIL:
            return false;
        default:
            return state;
    }
}
